import { fetchOpenPositions } from '../api/futures';
import { fetchSettingsStatus } from '../api/settings';

const DEFAULT_COINS = ['BTCUSDT', 'ETHUSDT'];

export async function getOpenPositions(): Promise<tradePosition[]> {
    try {
        const status = await fetchSettingsStatus();
        if (!status.hasKeys) return [];

        const data = await fetchOpenPositions();
        if (!data.success) return [];

        const coinList: string[] = JSON.parse(localStorage.getItem('coinList') || JSON.stringify(DEFAULT_COINS));

        for (const position of data.positions) {
            if (!coinList.includes(position.symbol)) {
                coinList.push(position.symbol);
            }
        }
        localStorage.setItem('coinList', JSON.stringify(coinList));

        return data.positions;
    } catch {
        return [];
    }
}
